import { render, staticRenderFns } from "./BusinessTow.vue?vue&type=template&id=931965da&scoped=true&"
import script from "./BusinessTow.vue?vue&type=script&lang=js&"
export * from "./BusinessTow.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTow.vue?vue&type=style&index=0&id=931965da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931965da",
  null
  
)

export default component.exports